import cn from 'classnames';
import Checkbox from '@creditflowresearch/uilib/Checkbox';
import { Radio, RadioGroup } from '@creditflowresearch/uilib/Radio';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import FilterItem from '@/creditflowresearch/ui/common/components/FilterItem';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import useStatusSection from './useStatusSection';
import useDroppedTranchesFilter from './useDroppedTranchesFilter';

import styles
  from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/checkboxFilter.module.scss';
import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import radioGroupStyles
  from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/radioGroup.module.scss';

const Status = () => {
  const { items, selectedValues, isAllSelected, isIndeterminate, toggle, toggleAll } = useStatusSection();
  const {
    selectedValue: droppedValue,
    onChange: onDroppedChange,
    options: droppedOptions,
  } = useDroppedTranchesFilter();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Status }
      header={ (
        <FilterSectionHeader
          title="STATUS"
          leftSlot={ (
            <Checkbox
              checked={ isAllSelected }
              onChange={ toggleAll }
              indeterminate={ isIndeterminate }
              supportIndeterminate
              dataTest="statusFiltersAllCheckbox"
            />
          ) }
        />
      ) }
    >
      <div className={ cn(styles.columns3, spacesStyles.mbl) }>
        { items.map((item) => (
          <FilterItem key={ item.value } isExpandable={ false }>
            <Checkbox
              label={ item.name }
              checked={ selectedValues.includes(item.value) }
              onChange={ () => toggle(item.value) }
              dataTest={ `checkbox-status-${ item.value }` }
            />
          </FilterItem>
        )) }
      </div>
      <RadioGroup
        name="droppedTranches"
        dataTest="droppedTranchesRadioGroup"
        selectedValue={ droppedValue }
        onChange={ onDroppedChange }
        label="Dropped Tranches"
        isNarrow
        className={ radioGroupStyles.radioGroup }
      >
        { droppedOptions.map((option) => (
          <Radio
            key={ String(option.value) }
            value={ option.value }
            label={ option.label }
            dataTest={ `radio-dropped-${ String(option.value) }` }
          />
        )) }
      </RadioGroup>
    </FilterSection>
  );
};

export default Status;
